import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import useCurrentUser from 'hooks/useCurrentUser';
import { ERoleCode } from 'types/enumItems';
import s from './s.module.less';

type Props = {
    onClose: () => void;
};

const BillingCalendarBanner = ({ onClose }: Props) => {
    const navigate = useNavigate();
    // 与 AskChartBanner 的 Get started 同口径：group 非 owner 成员直接去 insurance-billing
    // gate 页，不进 owner 向导；solo / owner 照常，canBind 权威判定由向导挂载守卫兜底
    const [currentUser] = useCurrentUser();
    const isGroupTeamMember = !!currentUser?.groupPractice && currentUser?.roleCode !== ERoleCode.GROUP_OWNER;

    return (
        <div className={s.wrap}>
            <span className={s.copy}>
                Every appointment on your calendar can be billed to insurance: Klarity Health and your connected EHRs
                (Healthie, IntakeQ, Tebra, SimplePractice and more) alike. Klarity drafts, submits, and works denials at
                3.9%, and you only pay when you get paid.
            </span>
            <span
                className={s.cta}
                onClick={() =>
                    navigate(
                        isGroupTeamMember
                            ? `${PATH.DASHBOARD}/${PATH.INSURANCE_BILLING}`
                            : PATH.INSURANCE_BILLING_ONBOARDING,
                    )
                }
            >
                Get started
            </span>
            <span className={s.close} onClick={onClose} role="button" aria-label="Close" tabIndex={0}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                        d="M2 12L12 2M2 2L12 12"
                        stroke="#6B7280"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </div>
    );
};

export default BillingCalendarBanner;
